import { render, staticRenderFns } from "./FmxLegal.vue?vue&type=template&id=7770b2f3&"
import script from "./FmxLegal.vue?vue&type=script&lang=js&"
export * from "./FmxLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports